import { defineStore } from 'pinia'
import type { ProductFilter, ProductFilterState, ProductSorter } from '~/types/productFilter'
import productFilters from '~/config/productFilters.json'
import productSorters from '~/config/productSorters.json'
import { COLLECTIONS } from '~/lib/search/typesense'

export const useProductFilterStore = defineStore('productFilter', {
  state: (): ProductFilterState => ({
    productFilters: productFilters as ProductFilter[],
    productSorters: productSorters as ProductSorter[]
  }),
  getters: {
    getProductFilterByAttributePath: state => (path: string) => state.productFilters.find(f => f.attributePath === path) || null,
    getProductFiltersByCategoryPath: state => (categoryPath: string): ProductFilter[] => {
      return state.productFilters.filter(f =>
        (!f.includeInPaths || (f.includeInPaths && f.includeInPaths?.some((inc: string) => categoryPath.startsWith(inc))))
        && (!f.excludeFromPaths || (f.excludeFromPaths && !f.excludeFromPaths?.some((exc: string) => categoryPath.startsWith(exc))))
      )
    },
    getProductSortersInAisFormat: (state: ProductFilterState) => state.productSorters.map((s: ProductSorter) => {
      return {
        value: COLLECTIONS.products + s.indexAffix,
        label: s.label
      }
    })
  }
})
